import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppProfile } from '../../shared/app-profile/app-profile';

@Injectable({
    providedIn: 'root'
})
export class AppProfileService {
    constructor(private httpClient: HttpClient) {}

    public getData() {
        return this.httpClient.get<AppProfile>('assets/app.profile.json');
    }
}
